export default __webpack_public_path__ + "static/media/icon-members.a72c973b.svg";